<script>
import { acountList } from "@/router/default.js";
import { clearCookie } from "@/common/util";
const MapRoute = {
  ROLE_AGENT: "/index/StatisticsAgent",
  ROLE_GROUP_OPTOMETRIST: "/index/visionTrainTrack",
  ROLE_AGENT_OPTOMETRIST: "/index/visionTrainTrack",
  ROLE_DOCTOR: "/index/patientManagement",
  ROLE_SUPER_ADMIN: "/index/groupAccounts",
  ROLE_REGION_MANAGER: "/index/medicalEstablishment",
  ROLE_AGENT_FINANCIAL: "/index/salesManagement",
  ROLE_STATION_MANAGER: "/index/visionTrainTrack"
};
export default {
  data() {
    return {
      username: "",
      password: "",
      isProductinformation: "",
      homeId: "",
      selectStation: false,
      showNotice: false,
      stationList: [],
      selectStationForm: []
    };
  },
  computed: {
    inElectron() {
      return this.$electron;
    }
  },
  methods: {
    async login() {
      let token = await this.$http.login(this.username, this.password);
      if (token) {
        let data = await this.$http.getHome(token);
        let role = data.roles[0];
        if (data.roles.indexOf("ROLE_PATIENT") > -1) {
          this.$message.error("管理端不支持患者登录！");
        } else {
          this.getHomeAndGoOn(data, token);
        }
      }
    },
    async getHomeAndGoOn(data, token) {
      clearCookie();
      console.log(
        "stationDirector>>>>>>>>>",
        this.$cookie.get("stationDirector")
      );
      localStorage.setItem("token", token);
      localStorage.setItem("username", this.username);
      this.$cookie.set("token", token);
      this.$cookie.set("username", this.username);
      let role = data.roles[0];
      localStorage.setItem("roles", data.roles);
      localStorage.setItem("loginName", data.user.name);
      if (data.actorDetail && data.actorDetail.coursePrice) {
        localStorage.setItem(
          "coursePrice",
          JSON.stringify(data.actorDetail.coursePrice)
        );
      }

      this.$cookie.set("id", data.user.id);
      this.$cookie.set("showPrompt", data.user.showPrompt);
      if (
        data.roles.indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
        data.roles.indexOf("ROLE_DOCTOR") > -1 ||
        data.roles.indexOf("ROLE_STATION_MANAGER") > -1
      ) {
        let stationList = await this.$http.getAgentStationList();

        if (stationList.length > 0) {
          let hadDirector = false;
          const AgentStationList = stationList.map(o => {
            if (o.isDirector) {
              hadDirector = true;
            }
            return {
              label: `${o.name}${o.isDirector ? "（主管医院）" : ""}`,
              keyName: o.stationUUID,
              director: o.isDirector,
              coursePrice: o.coursePrice
            };
          });
          this.$cookie.set("hadDirector", hadDirector);
          this.stationList = AgentStationList;
          // 如果只有一条记录，直接选择并进入系统
          if (AgentStationList.length === 1) {
            this.onSelectStation({ station: AgentStationList[0].keyName });
          } else {
            // 如果有两条或以上记录，才显示选择窗口
            let temp = [
              {
                keyName: "station",
                type: "select",
                children: AgentStationList
              }
            ];
            this.selectStationForm = temp;
            this.selectStation = true;
          }
        } else {
          this.showNotice = true;
        }
      } else {
        const routeArr = [];
        data.roles.forEach(element => {
          if (MapRoute[element]) {
            routeArr.push(MapRoute[element]);
          }
        });
        if (routeArr.length > 0) {
          this.$router.push({
            path: routeArr[0]
          });
        } else {
          this.$router.replace(acountList);
        }
      }
    },
    onSelectStation(data) {
      if (data.station) {
        const ROLE_AGENT_OPTOMETRIST =
          localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1;
        const ROLE_STATION_MANAGER =
          localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
        const activeStation = this.stationList.filter(
          o => o.keyName === data.station
        )[0];
        const stationDirector = activeStation.director;
        // const stationDirector = true;
        const coursePrice = activeStation.coursePrice;
        const stationName = activeStation.label;
        this.$cookie.set("stationId", data.station);
        this.$cookie.set("stationName", stationName);
        this.$cookie.set("stationDirector", stationDirector);
        this.$cookie.set("stationCoursePrice", coursePrice);
        this.selectStation = false;
        if (ROLE_AGENT_OPTOMETRIST && ROLE_STATION_MANAGER) {
          this.$router.push({
            path: MapRoute["ROLE_AGENT_OPTOMETRIST"]
          });
        } else {
          this.$router.push({
            path: MapRoute["ROLE_DOCTOR"]
          });
        }
      }
    },
    onClickForgetPwd() {
      this.$router.push({
        path: `/findPassword`
      });
    }
  }
};
</script>

<template>
  <div class="Login">
    <Login
      :username.sync="username"
      :password.sync="password"
      @confirm="login"
      @onClickForgetPwd="onClickForgetPwd"
      :newForgetPwd="true"
    ></Login>
    <DialogForm
      v-if="selectStation"
      formTitle="选择医院"
      :formInputArray="selectStationForm"
      @close="selectStation = false"
      @submitForm="onSelectStation"
      :isSelectSingle="true"
    />
    <DialogForm
      v-if="showNotice"
      formTitle="很抱歉，您当前未关联任何医院"
      @close="showNotice = false"
      @submitForm="showNotice = false"
      confirmButton="确认"
    />
    <Productinformation
      v-if="isProductinformation"
      :hide-close="false"
      @close="closeProductionLog"
      @confirm="ikonwProductionLog"
      :platform="inElectron?'PC端':'WEB端'"
    ></Productinformation>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/login/Login.vue